import React, { FC } from 'react';
import { SVGProps } from '@utils';
import { SvgWrapper } from './SvgWrapper';

export const GrayArrowRight: FC<SVGProps> = ({ onClick, divClassName }) => (
  <SvgWrapper
    divClassName={divClassName}
    onClick={onClick}
  >
    <svg xmlns="http://www.w3.org/2000/svg" width="7" height="10" viewBox="0 0 7 10" fill="none">
      <path d="M0.816895 8.825L4.6419 5L0.816895 1.175L2.00023 1.0345e-07L7.00023 5L2.00023 10L0.816895 8.825Z" fill="#848A95" />
    </svg>
  </SvgWrapper>
);
